module.exports = __webpack_public_path__ + "img/icons-fill-field.d033bb03.svg";